/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2018 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the property of
 * Pearson Education, Inc. The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S.
 * and Foreign Patents, patent applications, and are protected by trade secret
 * or copyright law. Dissemination of this information, reproduction of this
 * material, and copying or distribution of this software is strictly forbidden
 * unless prior written permission is obtained from Pearson Education, Inc.
 */

import {SET_ACCESS_CODE_INFO, SET_SPW_ACCESS_CODE, SET_SUBSCRIPTION_LENGTH} from "../_actions/access.code.actions";

export const INITIAL_STATE = {
    spwAccessCode:"",
    subscriptionLength: 180
};

export function accessCodeReducer (state = INITIAL_STATE, action) {
    switch (action.type) {
        case SET_SPW_ACCESS_CODE: {
            return {...state, spwAccessCode: action.payload};
        }
        case SET_SUBSCRIPTION_LENGTH: {
            return {...state, subscriptionLength: parseInt(action.payload)};
        }
        case SET_ACCESS_CODE_INFO: {
            return action.payload;
        }
        default: {
            return state;
        }
    }
}


// WEBPACK FOOTER //
// ./src/_reducers/access.code.reducer.js